/* jshint esversion: 6 */
/* jshint esversion: 11 */
import { useEffect, useState, useCallback, useContext, useRef } from 'react';
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import secureLocalStorage from "react-secure-storage";
const Razorpay = ({ Amount, Attribute }) => {

    const { setPaymentStatus, setTransactionId } = useContext(MyContext);

    const [userData, setUserData] = useState();
    const opened = useRef(false);

    const openPayModal = useCallback(() => {

        const options = {
            key: String(Attribute || '').split(',')[0].trim(),
            amount: Amount * 100,
            name: "RapidMediK",
            description: "some description",
            image: "https://cdn.razorpay.com/logos/7K3b6d18wHwKzL_medium.png",
            handler: (response) => {
                // console.log(response.razorpay_payment_id);
                setTransactionId(response.razorpay_payment_id);
                setPaymentStatus("PaymentDone");
            },
            modal: {
                ondismiss: () => {
                    setPaymentStatus("PaymentFaild");
                    showToast({ title: "Payment Closed !!", id: "info" })
                }
            },
            prefill: {
                name: userData && userData?.name,
                contact: userData && userData?.phone,
                email: userData && userData?.email,
            },
            notes: {
                address: "some address",
            },
            theme: {
                color: "#F37254",
                hide_topbar: false,
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();

    }, [Amount, userData]);

    useEffect(() => {
        const localData = secureLocalStorage.getItem("Loginuser");
        if (!Amount || !localData) return;

        const parsedData = typeof localData === "string" ? JSON.parse(localData) : localData;
        setUserData(parsedData);

    }, [Amount]);

    useEffect(() => {
        if (userData && Amount && !opened.current) {
            opened.current = true;
            openPayModal();
        }
    }, [Amount, userData, openPayModal]);

    return null;
};

export default Razorpay;
